/* Roughly 200 words a minute, counted off the body copy alone.
   Shared so the article hero and the journal index can never disagree. */
export const readingTime = (body: string[]): string => {
    const words = body
        .join(' ')
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0)
        .length

    return `${Math.max(1, Math.ceil(words / 200))} min read`
}
